import * as React from "react";
import { Modal, Button, Loader, Grid } from "semantic-ui-react";

import { useDispatch } from "@teamprevent/admin-redux";

import { goToParent } from "@teamprevent/common/routing";

import { PpqDeclarationReviewApi } from "../PpqDeclarationReviewApi";

interface Props {
    customerId: string;
    ohCaseId: string;
    taskId: string;
    ppqId: string;
}

const ViewPpqDeclarationReviewModal: React.FunctionComponent<Props> = (props) => {
    const [notes, setNotes] = React.useState<string>();
    const dispatch = useDispatch();

    React.useEffect(() => {
        (async () => {
            const response = await PpqDeclarationReviewApi.load(props.customerId, props.ohCaseId, props.taskId);
            setNotes(response.notes);
        })();
    });

    const onClose = () => dispatch(goToParent());

    return (
        <Modal open>
            <Modal.Header>
                <Grid columns="equal">
                    <Grid.Column>Review PPQ Declaration</Grid.Column>
                    <Grid.Column>
                        <a
                            href={`/case/${props.ppqId}/ppq`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button floated="right" content="Review PPQ" />
                        </a>
                    </Grid.Column>
                </Grid>
            </Modal.Header>
            <Modal.Content>
                {notes ?
                    <>
                        <label>Notes</label>
                        <div>{notes}</div>
                    </> :
                    <Loader active />
                }
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Close</Button>
            </Modal.Actions>
        </Modal>
    );
};

export { ViewPpqDeclarationReviewModal };
